/* eslint semi:0 */
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import reduxMount from '../../jsCore/utils/reduxMounter'
import { queryString } from '../../jsCore/utils/window'
import { warn, info } from '../../jsCore/application/console'
import { fantasyReducer } from './fantasyReducer'
import { fantasyActions } from './fantasyActions'
import { fantasyConfig } from './fantasyMounterConfig'
import { isCampaignEnabled } from '../../jsCore/config/campaignConfig'
import FantasyComponent from './components/fantasyComponent'
import { MOUNT_POINTS } from '../../jsCore/config/preRenderedSelectorsConfig'
import { injectFantasyInsideArticle } from './fantasyNodeInjector'

const { YAHOO_FANTASY_MOUNT_POINT } = MOUNT_POINTS
const COMPONENT_NAME = 'FantasyContainer'
const STATE_KEY = 'fantasy'
const IS_YAHOO_FANTASY_ENABLED = true
const { forceFantasy } = queryString

function mapStateToProps(state) {
  const { isInitialized, tournaments, numVisibleTournaments, isLoadMoreVisible } = state[STATE_KEY]
  return {
    isInitialized,
    tournaments,
    numVisibleTournaments,
    isLoadMoreVisible,
  }
}

const FantasyContainer = {
  name: COMPONENT_NAME,
  stateKey: STATE_KEY,
  component: connect(mapStateToProps, fantasyActions)(FantasyComponent),
  reducer: fantasyReducer,
}

function injectAndMount() {
  injectFantasyInsideArticle()
  reduxMount({
    [YAHOO_FANTASY_MOUNT_POINT]: FantasyContainer,
  })
}

function injectAndMountFantasyIfEnabled({ isCampaignEnabled: isFantasyCampaignEnabled }) {
  if (isFantasyCampaignEnabled) {
    injectAndMount()
  }
}

export default function mountFantasyComponent() {
  if (forceFantasy) {
    info('[YAHOO_FANTASY] forcing mount', fantasyConfig)
    return Promise.resolve(injectAndMount())
  }
  return (
    IS_YAHOO_FANTASY_ENABLED &&
    isCampaignEnabled(fantasyConfig).then(injectAndMountFantasyIfEnabled).catch(warn)
  )
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/fantasy/fantasyMounter.js